export enum Permissions {
  OFFICE_GROUP_SUPER_ADMIN = 'OFFICE_GROUP_SUPER_ADMIN',
  OFFICE_GROUP_OWNER = 'OFFICE_GROUP_OWNER',
  OFFICE_GROUP_ROTP = 'OFFICE_GROUP_ROTP',
  OFFICE_GROUP_SUPPORT = 'OFFICE_GROUP_SUPPORT',
  OFFICE_GROUP_ACCOUNT_MANAGER = 'OFFICE_GROUP_ACCOUNT_MANAGER',
  OFFICE_GROUP_DEVELOPER = 'OFFICE_GROUP_DEVELOPER',
  OFFICE_GROUP_ROP = 'OFFICE_GROUP_ROP',
  OFFICE_ROLES_CREATE = 'OFFICE_ROLES_CREATE',
  OFFICE_ROLES_OBSERVE = 'OFFICE_ROLES_OBSERVE',
  OFFICE_ROLES_EDIT = 'OFFICE_ROLES_EDIT',
  OFFICE_ROLES_DELETE = 'OFFICE_ROLES_DELETE',
  OFFICE_SHOP_COMPANY_OBSERVE = 'OFFICE_SHOP_COMPANY_OBSERVE',
  OFFICE_SHOP_COMPANY_CREATE = 'OFFICE_SHOP_COMPANY_CREATE',
  OFFICE_SHOP_COMPANY_EDIT = 'OFFICE_SHOP_COMPANY_EDIT',
  OFFICE_SHOP_COMPANY_DELETE = 'OFFICE_SHOP_COMPANY_DELETE',
  OFFICE_SHOP_COMPANY_RESTORE = 'OFFICE_SHOP_COMPANY_RESTORE',
  OFFICE_SHOP_COMPANY_ACTIVATE = 'OFFICE_SHOP_COMPANY_ACTIVATE',
  OFFICE_SHOP_COMPANY_EDIT_OWNER = 'OFFICE_SHOP_COMPANY_EDIT_OWNER',
  OFFICE_SHOP_COMPANY_SET_OFFICE = 'OFFICE_SHOP_COMPANY_SET_OFFICE',
  OFFICE_SHOP_COMPANY_LIST_BY_TARIFF_PLAN = 'OFFICE_SHOP_COMPANY_LIST_BY_TARIFF_PLAN',
  OFFICE_DISTRIBUTOR_COMPANY_CREATE = 'OFFICE_DISTRIBUTOR_COMPANY_CREATE',
  OFFICE_DISTRIBUTOR_ALLOWED_STORE_CREATE = 'OFFICE_DISTRIBUTOR_ALLOWED_STORE_CREATE',
  OFFICE_DISTRIBUTOR_REPORT_OBSERVE = 'OFFICE_DISTRIBUTOR_REPORT_OBSERVE',
  OFFICE_DISTRIBUTOR_ALLOWED_STORE_EDIT = 'OFFICE_DISTRIBUTOR_ALLOWED_STORE_EDIT',
  OFFICE_DISTRIBUTOR_REPORT_VIEW = 'OFFICE_DISTRIBUTOR_REPORT_VIEW',
  OFFICE__OFFICE_COMPANY_OBSERVE = 'OFFICE__OFFICE_COMPANY_OBSERVE',
  OFFICE__OFFICE_COMPANY_CREATE = 'OFFICE__OFFICE_COMPANY_CREATE',
  OFFICE__OFFICE_COMPANY_EDIT = 'OFFICE__OFFICE_COMPANY_EDIT',
  OFFICE__OFFICE_COMPANY_DELETE = 'OFFICE__OFFICE_COMPANY_DELETE',
  OFFICE__MASTER_OFFICE_COMPANY_CREATE = 'OFFICE__MASTER_OFFICE_COMPANY_CREATE',
  OFFICE_STORE_OBSERVE = 'OFFICE_STORE_OBSERVE',
  OFFICE_STORE_CREATE = 'OFFICE_STORE_CREATE',
  OFFICE_STORE_EDIT = 'OFFICE_STORE_EDIT',
  OFFICE_STORE_CLEAR = 'OFFICE_STORE_CLEAR',
  OFFICE_STORE_DELETE = 'OFFICE_STORE_DELETE',
  OFFICE_STORE_RESTORE = 'OFFICE_STORE_RESTORE',
  OFFICE_STORE_BIND_SUPPORT = 'OFFICE_STORE_BIND_SUPPORT',
  OFFICE__OFFICE_USER_OBSERVE = 'OFFICE__OFFICE_USER_OBSERVE',
  OFFICE__OFFICE_USER_CREATE = 'OFFICE__OFFICE_USER_CREATE',
  OFFICE__OFFICE_USER_EDIT = 'OFFICE__OFFICE_USER_EDIT',
  OFFICE__OFFICE_USER_DELETE = 'OFFICE__OFFICE_USER_DELETE',
  OFFICE__OFFICE_USER_RESTORE = 'OFFICE__OFFICE_USER_RESTORE',
  OFFICE_COMPANY_TARIFF_PLAN_OBSERVE = 'OFFICE_COMPANY_TARIFF_PLAN_OBSERVE',
  OFFICE_COMPANY_TARIFF_PLAN_EDIT = 'OFFICE_COMPANY_TARIFF_PLAN_EDIT',
  OFFICE_BILLING_PAYMENT_OBSERVE = 'OFFICE_BILLING_PAYMENT_OBSERVE',
  OFFICE_BILLING_PAYMENT_CREATE = 'OFFICE_BILLING_PAYMENT_CREATE',
  OFFICE_BILLING_PAYMENT_REFUND = 'OFFICE_BILLING_PAYMENT_REFUND',
  OFFICE_APPLICATION_OBSERVE = 'OFFICE_APPLICATION_OBSERVE',
  OFFICE_APPLICATION_CREATE = 'OFFICE_APPLICATION_CREATE',
  OFFICE_NOTIFICATION_OBSERVE = 'OFFICE_NOTIFICATION_OBSERVE',
  OFFICE_NOTIFICATION_CREATE = 'OFFICE_NOTIFICATION_CREATE',
  OFFICE_NOTIFICATION_EDIT = 'OFFICE_NOTIFICATION_EDIT',
  SHOP_ORDER_MODIFY_ALLOWED_STORES = 'SHOP_ORDER_MODIFY_ALLOWED_STORES',
  OFFICE_NLS_REPORT_MANAGE = 'OFFICE_NLS_REPORT_MANAGE',
  OFFICE__OFFICE_COMPANY_INCOME_SHARE_OBSERVE = 'OFFICE__OFFICE_COMPANY_INCOME_SHARE_OBSERVE',
  OFFICE__OFFICE_COMPANY_INCOME_SHARE_CREATE = 'OFFICE__OFFICE_COMPANY_INCOME_SHARE_CREATE',
  OFFICE__OFFICE_COMPANY_INCOME_SHARE_EDIT = 'OFFICE__OFFICE_COMPANY_INCOME_SHARE_EDIT',
  OFFICE_SALES_MANAGER_GRADING_EDIT = 'OFFICE_SALES_MANAGER_GRADING_EDIT',
  OFFICE_SALES_MANAGER_REGRADE = 'OFFICE_SALES_MANAGER_REGRADE',
  OFFICE_SHOP_COMPANY_fisc_report_observe = 'OFFICE_SHOP_COMPANY_FISC_REPORT_OBSERVE',
  OFFICE_SHOP_COMPANY_fisc_report_edit = 'OFFICE_SHOP_COMPANY_FISC_REPORT_EDIT',
  OFFICE_SHOP_COMPANY_EDIT_ANY_FIELDS = 'OFFICE_SHOP_COMPANY_EDIT_ANY_FIELDS',
  OFFICE_REFERRAL_REPORT_OBSERVE = 'OFFICE_REFERRAL_REPORT_OBSERVE',
}
